module.exports = __webpack_public_path__ + "img/IMG_6726_L_Foamcore.9be1eeb4.jpg";